import { Injectable, NgZone } from '@angular/core';
import * as fromPassesAction from '../actions/passes.action';
import * as fromOrganizationActions from '../actions/organization.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TokenService } from 'src/app/services/token.service';
import { APIResponse } from 'src/app/models/api-response.model';
import {map, mergeMap, filter, tap} from 'rxjs/operators';
import { RouterNavigatedAction, ROUTER_NAVIGATION } from '@ngrx/router-store';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { PassService } from 'src/app/services/pass.service';

@Injectable()
export class PassesEffects {

    getPassesForSale$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        filter((r : RouterNavigatedAction) => {
            return r.payload.routerState.url.startsWith('/home/passes')
        }),
        mergeMap(() => {
          return this.passesService.getPassForSale().pipe(
            map((response: APIResponse) => {
              console.log('getPassesForSale$', response);
              return fromPassesAction.getPassesForSaleSuccess({data: response?.details});
            })
          );
        })
      )
    );

    // getUserPasses$ = createEffect(() =>
    //   this.actions$.pipe(
    //     ofType(ROUTER_NAVIGATION),
    //     filter((r : RouterNavigatedAction) => {
    //         return r.payload.routerState.url.startsWith('/home/bottom-tabs/pass')
    //          || r.payload.routerState.url.startsWith('/home/bottom-tabs/dashboard')
    //          || r.payload.routerState.url.startsWith('/home/bottom-tabs/ride');
    //     }),
    //     mergeMap(() => {
    //       return this.passesService.getUserPasses().pipe(
    //         map((response: APIResponse) => {
    //           console.log('getUserPasses$', response);
    //           return fromOrganizationActions.getUserPassesSuccess({data: response?.details});
    //         })
    //       );
    //     })
    //   )
    // );

    reloadUserPass$ = createEffect(() =>
      this.actions$.pipe(
        ofType(fromPassesAction.reloadUserPass),
        mergeMap(() => {
          return this.passesService.getUserPasses().pipe(
            map((response: APIResponse) => {
              console.log('reloadUserPass$', response);
              return fromOrganizationActions.getUserPasses();
            })
          );
        })
      )
    );

    updatePassCart$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(fromPassesAction.updatePassCart),
          tap(async (action) => {
            console.log('updateTokenCart$', action?.data);
          })  
        ),
      { dispatch: false }
    );

  constructor (
    private actions$: Actions,
    private passesService: PassService,
    private offlineService: OfflineStorageService
  ) {}
}